import { DurabilityPreferences } from '../../../../types';
export var list = [
    DurabilityPreferences.FALSE,
    DurabilityPreferences.NON_SPECIFIC_TRUE,
    DurabilityPreferences.SPECIFIC_TRUE,
];
